import { __assign, __extends } from "tslib";
import { InputText } from '@victorequena22/component-bootstrap';
import React from 'react';
import { Button, InputGroup } from 'react-bootstrap';
import { busqueda, ordenar } from '@victorequena22/utiles';
import Body from './Body';
import Th from './Th';
var Tabla = /** @class */ (function (_super) {
    __extends(Tabla, _super);
    function Tabla(p) {
        var _this = _super.call(this, p) || this;
        _this.buscarEn = [];
        _this.fechas = [];
        _this.buscarLabel = 'BUSCAR';
        _this.col = 8;
        _this.mostar = 7;
        _this.state = {
            itens: [],
            buscar: '',
            by: 'id',
            orden: 'desc',
            modal: false,
            open: false,
            aux: false,
            dolar: false
        };
        _this.setState = _this.setState.bind(_this);
        _this.Buscador = _this.Buscador.bind(_this);
        _this.busqueda = _this.busqueda.bind(_this);
        _this.Body = _this.Body.bind(_this);
        _this.Header = _this.Header.bind(_this);
        _this.Row = _this.Row.bind(_this);
        _this.Th = _this.Th.bind(_this);
        return _this;
    }
    Tabla.prototype.Buscador = function () {
        return (React.createElement(InputGroup, { style: { paddingBottom: '15px' } },
            React.createElement(InputGroup.Prepend, null,
                React.createElement(InputGroup.Text, null, this.buscarLabel)),
            React.createElement(InputText, { className: 'form-control', upper: true, setData: this.setState, update: 'buscar', value: this.state.buscar }),
            React.createElement(InputGroup.Append, null,
                React.createElement(Button, { variant: 'primary' },
                    React.createElement("span", { className: 'fa fa-search' }),
                    " BUSCAR"))));
    };
    Tabla.prototype.Th = function (p) {
        var _a = this, setState = _a.setState, _b = _a.state, by = _b.by, orden = _b.orden;
        return React.createElement(Th, __assign({}, p, { setOrden: setState, by: by, orden: orden }));
    };
    Tabla.prototype.Body = function () {
        var _a = this, col = _a.col, mostar = _a.mostar, Row = _a.Row, Header = _a.Header;
        return (React.createElement(Body, { mostrar: mostar, col: col, row: Row, itens: this.filter() },
            React.createElement(Header, null)));
    };
    Tabla.prototype.render = function () {
        var _a = this, Body = _a.Body, Buscador = _a.Buscador;
        return (React.createElement(React.Fragment, null,
            React.createElement(Buscador, null),
            React.createElement(Body, null)));
    };
    Tabla.prototype.Header = function () {
        return React.createElement(React.Fragment, null);
    };
    Tabla.prototype.Row = function (p) {
        console.log(p);
        return React.createElement(React.Fragment, null);
    };
    Tabla.prototype.getItens = function () {
        return this.state.itens;
    };
    Tabla.prototype.filter = function () {
        return this.ordenar();
    };
    Tabla.prototype.busqueda = function () {
        var _a = this, buscar = _a.state.buscar, buscarEn = _a.buscarEn, fechas = _a.fechas;
        return busqueda(this.getItens(), buscar, buscarEn, fechas);
    };
    Tabla.prototype.ordenar = function () {
        var _a = this, _b = _a.state, by = _b.by, orden = _b.orden, busqueda = _a.busqueda, fechas = _a.fechas;
        return ordenar(busqueda(), by, orden, fechas);
    };
    return Tabla;
}(React.Component));
export default Tabla;
//# sourceMappingURL=index.js.map